const pendingRequests = new Map<string, Promise<any>>();

function generateRequestKey(url: string, options?: RequestInit): string {
  const method = options?.method || 'GET';
  const body = options?.body ? String(options.body).substring(0, 200) : '';
  return `${method}:${url}:${body}`;
}

export function getPendingRequest(key: string): Promise<any> | undefined {
  return pendingRequests.get(key);
}

export function setPendingRequest(key: string, promise: Promise<any>): void {
  pendingRequests.set(key, promise);
  promise.finally(() => pendingRequests.delete(key));
}

export function makeRequestKey(url: string, options?: RequestInit): string {
  return generateRequestKey(url, options);
}

export function isGetRequest(options?: RequestInit): boolean {
  return !options?.method || options.method === 'GET';
}
